import { NavLink, useLocation } from "react-router-dom";
import { Settings } from "lucide-react";
import { MAIN_NAV, SETTINGS_GROUPS } from "@/lib/nav";
import { useSession } from "@/context/SessionContext";
import { cn } from "@/lib/utils";

export const BrandMark = ({ collapsed }) => (
  <div className="flex items-center gap-2.5 px-4 h-16 border-b" data-testid="brand-mark">
    <div className="h-8 w-8 shrink-0 rounded-md bg-gold flex items-center justify-center font-display font-extrabold text-[#1F2328] text-sm">39</div>
    {!collapsed && (
      <div className="leading-tight">
        <div className="font-display font-bold tracking-tight">Garage39</div>
        <div className="text-[10px] uppercase tracking-[0.18em] text-muted-foreground">By Route39</div>
      </div>
    )}
  </div>
);

const NavItem = ({ item, collapsed, onNavigate, active }) => {
  const Icon = item.icon;
  return (
    <NavLink
      to={item.path}
      end={item.path === "/"}
      onClick={onNavigate}
      title={collapsed ? item.label : undefined}
      data-testid={`nav-${item.key}`}
      className={({ isActive }) => cn(
        "relative flex items-center gap-3 rounded-md px-3 py-2.5 text-sm transition-colors",
        isActive || active ? "bg-accent text-foreground font-medium" : "text-muted-foreground hover:text-foreground hover:bg-secondary",
      )}
    >
      {({ isActive }) => (
        <>
          {(isActive || active) && <span className="absolute left-0 top-2 bottom-2 w-[3px] rounded-r bg-gold" />}
          <Icon className={cn("h-[18px] w-[18px] shrink-0", (isActive || active) && "text-gold")} />
          {!collapsed && <span className="truncate">{item.label}</span>}
        </>
      )}
    </NavLink>
  );
};

export const Sidebar = ({ collapsed = false, onNavigate }) => {
  const { can } = useSession();
  const { pathname } = useLocation();
  const settingsItems = SETTINGS_GROUPS.flatMap((g) => g.items).filter((i) => can(i.perm));
  const inSettings = pathname === "/settings" || settingsItems.some((i) => pathname === i.path || pathname.startsWith(`${i.path}/`));
  return (
    <div className="flex h-full flex-col bg-white border-r" data-testid="sidebar">
      <BrandMark collapsed={collapsed} />
      <nav className="flex-1 overflow-y-auto g39-scroll px-2.5 py-4 space-y-1">
        {MAIN_NAV.filter((i) => can(i.perm)).map((i) => <NavItem key={i.key} item={i} collapsed={collapsed} onNavigate={onNavigate} />)}
      </nav>
      {settingsItems.length > 0 && (
        <div className="px-2.5 py-3 border-t">
          <NavItem item={{ key: "settings", label: "Settings", icon: Settings, path: "/settings" }} active={inSettings} collapsed={collapsed} onNavigate={onNavigate} />
        </div>
      )}
    </div>
  );
};
